import MenuPageItem from "./MenuPageItem";

export default function MenuPageItemOk({ formUtility, onClick }) {

    function handleOnClick(e) {
        if (!onClick || formUtility?.fieldsDisabled)
            return;
            
        onClick();
    }

    return (
        <>
            {
                onClick && (!formUtility || (formUtility.data && formUtility.hasChanges))
                    ? <MenuPageItem iconClassName="fas fa-check" text="OK" onClick={handleOnClick} />
                    : null
            }
        </>
    );
}